import { AsideMenuItem } from "./AsideMenuItem";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";

export function AsideMenuMain() {
	return (
		<>
			<div className="menu-item">
				<div className="menu-content pt-8 pb-2">
					<span className="menu-section text-muted text-uppercase fs-8 ls-1">
						Admin Portal
					</span>
				</div>
			</div>
			<AsideMenuItem
				to="/dashboard"
				icon="element-11"
				userRoles={[1, 2, 3, 4, 5]}
				title="Dashboard"
			/>

			<AsideMenuItemWithSub
				to="/"
				userRoles={[1, 2, 3, 4, 5]}
				title="Registration"
				icon="profile-user"
			>
				<AsideMenuItem
					to="/registration"
					icon="people"
					userRoles={[1, 2, 3, 4]}
					title="Staff Registration"
					exact={true}
				/>
				<AsideMenuItem
					to="/registration/state-officer"
					icon="profile-user"
					userRoles={[1, 2]}
					title="State Officer Registration"
				/>
				<AsideMenuItem
					to="/registration/vrp"
					icon="profile-user"
					userRoles={[1, 2, 3, 4, 5]}
					title="VRP Register"
				/>
			</AsideMenuItemWithSub>

			{/* <AsideMenuItem
					to="/registration/state"
					icon="minus"
					userRoles={[1, 2]}
					title="State level Office"
				/>
				<AsideMenuItem
					to="/registration/district"
					icon="minus"
					userRoles={[1, 2]}
					title="District level Office"
				/>
				 */}

			<AsideMenuItem
				to="/scheme-data-entry"
				userRoles={[1, 2, 3, 4]}
				title="Scheme Data Entry"
				icon="scheme"
			/>

			<AsideMenuItem
				to="/smars"
				icon="calendar-tick"
				userRoles={[1]}
				title="S-MARS"
			/>

			<AsideMenuItem
				to="/our-locations"
				icon="map"
				userRoles={[1, 3, 6]}
				title="Our Locations"
			/>

			<AsideMenuItem
				to="/master/calendar"
				icon="calendar-8"
				userRoles={[1, 3, 6]}
				title="Calendar"
			/>

			<AsideMenuItem
				to="/performance-review"
				icon="chart-simple"
				userRoles={[1, 3, 4]}
				title="Performance Review (Annual)"
			/>

			<AsideMenuItemWithSub
				to="/training"
				userRoles={[1, 2, 3, 4]}
				title="Training"
				icon="book-open"
			>
				<AsideMenuItem
					to="/training/batches"
					userRoles={[1, 2, 3, 4]}
					title="Batches"
					icon="grid"
				/>
				<AsideMenuItem
					to="/training/attendance"
					userRoles={[1, 2, 3, 4]}
					title="Attendance"
					icon="calendar-tick"
				/>
				<AsideMenuItem
					to="/training/materials"
					userRoles={[1, 2, 3, 4]}
					title="Materials"
					icon="book-open"
				/>
				<AsideMenuItem
					to="/training/types"
					userRoles={[1]}
					title="Training Types"
					icon="abstract-26"
				/>
			</AsideMenuItemWithSub>

			<AsideMenuItemWithSub
				to="/event"
				userRoles={[1, 2, 3, 4, 5]}
				title="Event"
				icon="calendar-8"
			>
				<AsideMenuItem
					to="/event"
					userRoles={[1, 2, 3, 4, 5]}
					title="All events"
					icon="grid"
					exact={true}
				/>
				<AsideMenuItem
					to="/event/calendar"
					userRoles={[1, 2, 3, 4, 5]}
					title="Calendar view"
					icon="calendar-8"
				/>
				<AsideMenuItem
					to="/event/attendance"
					userRoles={[1, 2, 3, 4, 5]}
					title="Attendance & ATR"
					icon="calendar-tick"
				/>
				<AsideMenuItem
					to="/event/photo-uploads"
					userRoles={[1, 2, 3, 4, 5]}
					title="Photo uploads"
					icon="camera"
				/>
			</AsideMenuItemWithSub>

			<AsideMenuItem
				to="/video-conference"
				userRoles={[1]}
				title="VC"
				icon="video"
			/>

			<AsideMenuItemWithSub
				to="/report"
				userRoles={[1, 2, 3, 4]}
				title="Report"
				icon="chart-line-star"
			>
				<AsideMenuItem
					to="/report/staff-registration"
					userRoles={[1, 2, 3, 4]}
					title="Staff registration report"
					icon="people"
				/>
				<AsideMenuItem
					to="/report/vrp-registration"
					userRoles={[1, 2, 3, 4]}
					title="VRP registration report"
					icon="profile-user"
				/>
				<AsideMenuItem
					to="/report/training"
					userRoles={[1, 2, 3, 4]}
					title="Training reports"
					icon="book-open"
				/>
				<AsideMenuItem
					to="/report/dsje-scheme"
					userRoles={[1, 2, 3, 4]}
					title="DOSJE scheme report"
					icon="landmark"
				/>
				<AsideMenuItem
					to="/report/scheme-data-entry"
					userRoles={[1, 2, 3, 4]}
					title="Scheme data entry report"
					icon="scheme"
				/>
				<AsideMenuItem
					to="/report/event"
					userRoles={[1, 2, 3, 4]}
					title="Event report"
					icon="calendar-8"
				/>
				<AsideMenuItem
					to="/report/mis"
					userRoles={[1, 2, 3, 4]}
					title="MIS Reports"
					icon="chart-line-star"
				/>
				<AsideMenuItem
					to="/report/internal"
					userRoles={[1]}
					title="Internal report"
					icon="clipboard-list"
				/>
				<AsideMenuItem
					to="/report/complaint"
					userRoles={[1, 2, 3, 4]}
					title="Complaint report"
					icon="complaint"
				/>
			</AsideMenuItemWithSub>

			<AsideMenuItemWithSub
				to="/master"
				userRoles={[1]}
				title="Master"
				icon="setting-2"
			>
				<AsideMenuItem
					to="/master/schemes"
					icon="scheme"
					userRoles={[1]}
					title="Scheme"
				/>
				<AsideMenuItem
					to="/master/event-type"
					icon="calendar-8"
					userRoles={[1]}
					title="Event Type"
				/>
				<AsideMenuItem
					to="/master/district"
					icon="map"
					userRoles={[1]}
					title="District"
				/>
				<AsideMenuItem
					to="/master/institute"
					icon="landmark"
					userRoles={[1]}
					title="Institute"
				/>
				<AsideMenuItem
					to="/master/block"
					icon="layers"
					userRoles={[1]}
					title="Block"
				/>
				<AsideMenuItem
					to="/master/village"
					icon="home"
					userRoles={[1]}
					title="Village"
				/>
				<AsideMenuItem
					to="/master/school"
					icon="home"
					userRoles={[1]}
					title="School"
				/>
				<AsideMenuItem
					to="/master/issue-type"
					icon="element-11"
					userRoles={[1]}
					title="Type"
				/>
				<AsideMenuItem
					to="/master/issue-category"
					icon="category"
					userRoles={[1]}
					title="Category"
				/>
				<AsideMenuItem
					to="/master/issue-sub-category"
					icon="abstract-26"
					userRoles={[1]}
					title="Sub Category"
				/>
				<AsideMenuItem
					to="/master/scheme-issue-mapping"
					icon="map"
					userRoles={[1]}
					title="Scheme Issue Mapping"
				/>
				<AsideMenuItem
					to="/master/classification"
					icon="abstract-26"
					userRoles={[1]}
					title="Classification"
				/>
				<AsideMenuItem
					to="/master/level"
					icon="layers"
					userRoles={[1]}
					title="Level"
				/>
				<AsideMenuItem
					to="/master/course"
					icon="book-open"
					userRoles={[1]}
					title="Course"
				/>
			</AsideMenuItemWithSub>

			<AsideMenuItem
				to="/user-management"
				icon="profile-circle"
				userRoles={[1]}
				title="User management"
			/>
		</>
	);
}
